(() => {
  if (window.VidtoutHeroVideo) return;
  window.VidtoutHeroVideo = true;

  const PLAYER_SELECTOR = 'vidtout-hero-video-player';

  function shouldSkipAutoplay() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return true;
    if (navigator.connection?.saveData) return true;
    return false;
  }

  function loadAndPlay(player) {
    const video = player.querySelector('video');
    const sources = player.querySelectorAll('source[data-video-source]');
    if (!video || !sources.length || player.dataset.vidtoutVideoReady === 'true') return;

    player.dataset.vidtoutVideoReady = 'true';

    sources.forEach((source) => {
      const url = source.dataset.videoSource;
      if (url) source.setAttribute('src', url);
    });

    video.load();

    const onPlaying = () => {
      player.classList.add('is-playing');
      video.removeEventListener('playing', onPlaying);
    };
    video.addEventListener('playing', onPlaying);

    const playPromise = video.play();
    if (playPromise) playPromise.catch(() => {});
  }

  function scheduleLoad(player) {
    if (shouldSkipAutoplay()) return;

    const run = () => loadAndPlay(player);

    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 2500 });
      return;
    }

    setTimeout(run, 1);
  }

  function initPlayer(player) {
    if (player.dataset.vidtoutVideoInit === 'true') return;
    player.dataset.vidtoutVideoInit = 'true';
    scheduleLoad(player);
  }

  function initAll(root = document) {
    root.querySelectorAll(PLAYER_SELECTOR).forEach(initPlayer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) initAll(event.target);
  });
})();
